import React from 'react';
import { Container } from 'react-bootstrap';

const VideoNotFound = () => {
  return (
    <Container>
      <h1>There doesn&apos;t seem to be anything here.</h1>
    </Container>
  );
};

export default VideoNotFound;
